import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "content",
  initialState: {
    methodology: [],
    wordoftheday: [],
    counterMethodology: [],
    academicProgressEN: "<p></p>",
    academicProgressES: "<p></p>",
    academicProgressPT: "<p></p>",
    academicProgressFR: "<p></p>",
    methodologyLingoEN: "<p></p>",
    methodologyLingoES: "<p></p>",
    methodologyLingoPT: "<p></p>",
    methodologyLingoFR: "<p></p>",
    methodologyLingoENInterview: "<p></p>",
    methodologyLingoESInterview: "<p></p>",
    methodologyLingoPTInterview: "<p></p>",
    methodologyLingoFRInterview: "<p></p>",
    wordofthedayByDate: {},
  },
  reducers: {
    setMethodology(state, { payload }) {
      state.methodology = payload;
    },
    setWordoftheday(state, { payload }) {
      state.wordoftheday = payload;
    },
    setCounterMethodology(state, { payload }) {
      state.counterMethodology = payload;
    },
    setAcademicProgressEN(state, { payload }) {
      state.academicProgressEN = payload;
    },
    setAcademicProgressES(state, { payload }) {
      state.academicProgressES = payload;
    },
    setAcademicProgressPT(state, { payload }) {
      state.academicProgressPT = payload;
    },
    setAcademicProgressFR(state, { payload }) {
      state.academicProgressFR = payload;
    },
    setMethodologyLingoEN(state, { payload }) {
      state.methodologyLingoEN = payload;
    },
    setMethodologyLingoES(state, { payload }) {
      state.methodologyLingoES = payload;
    },
    setMethodologyLingoPT(state, { payload }) {
      state.methodologyLingoPT = payload;
    },
    setMethodologyLingoFR(state, { payload }) {
      state.methodologyLingoFR = payload;
    },
    setWordofthedayByDate(state, { payload }) {
      state.wordofthedayByDate = payload;
    },
    setMethodologyLingoENInterview(state, { payload }) {
      state.methodologyLingoENInterview = payload;
    },
    setMethodologyLingoESInterview(state, { payload }) {
      state.methodologyLingoESInterview = payload;
    },
    setMethodologyLingoPTInterview(state, { payload }) {
      state.methodologyLingoPTInterview = payload;
    },
    setMethodologyLingoFRInterview(state, { payload }) {
      state.methodologyLingoFRInterview = payload;
    },
  },
});

export const {
  setMethodology,
  setWordoftheday,
  setCounterMethodology,
  setAcademicProgressEN,
  setAcademicProgressES,
  setAcademicProgressPT,
  setAcademicProgressFR,
  setMethodologyLingoEN,
  setMethodologyLingoES,
  setMethodologyLingoPT,
  setMethodologyLingoFR,
  setMethodologyLingoENInterview,
  setMethodologyLingoESInterview,
  setMethodologyLingoPTInterview,
  setMethodologyLingoFRInterview,
  setWordofthedayByDate,
} = userSlice.actions;

export default userSlice.reducer;
